import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { NgxSpinnerModule } from 'ngx-spinner';
import { Spinner } from '../../enums';

@Component({
  selector: 'smata-page-loader-spinner',
  standalone: true,
  imports: [CommonModule, NgxSpinnerModule],
  templateUrl: './page-loader-spinner.component.html',
  styleUrl: './page-loader-spinner.component.scss',
})
export class SmataPageLoaderSpinnerComponent {
  @Input() fullScreen: boolean | undefined;

  get name() {
    return this.fullScreen ? Spinner.FullScreen : Spinner.PartialScreen;
  }

  private readonly uuid = crypto.randomUUID();
}
